import api from '../bu/api';

export default {
    namespaced: true,

    state: () => ({
        paging: null,
        invoices: []
    }),

    getters: {
        invoices(state) {
            return state.invoices;
        },
        paging(state) {
            return state.paging;
        }
    },

    actions: {
        async getInvoices({ commit }, page) {
            const response = await api.getInvoices(page);
            console.log('11', [page, response.data]);
            commit('setAPIResponse', { page, response });
        },
    },

    mutations: {
        setAPIResponse(state, { page, response}) {
            state.paging = {
                current_page: response.data.current_page,
                total: response.data.total,
                last_page: response.data.last_page,
            };
            state.invoices = response.data.data;
        }
    },
}